import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import { axiosApi } from "../../../api/helper";
import InsButton from "../../../components/InsButton/InsButton";
import InsInput from "../../../components/InsInput/InsInput";
import Validate from "../../../ressources/validation";
import FixedLangSwitcher from "../../../components/FixedLangSwitcher/FixedLangSwitcher";
import ValidatePassword from "../../../components/ValidatePassword/ValidatePassword";
import { changePassword } from "../../../api/account";
import * as accountActions from "../../../store/actions/accountActions";
import { connect } from "react-redux";
import ConnectOptin from "components/ConnectOptin/ConnectOptin";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      new_password: "",
      confirm_password: "",
      email_error: "",
      passwordError: "",
      newPasswordError: "",
      confirmPasswordError: "",
      formError: null,
      redirect: false,
      optins: [],
      fields: [],
      newsletter: false,
      validConsent: false
    };
  }

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  _validatePasswordConfirm = () => {
    const { new_password, confirm_password } = this.state;
    const { t } = this.props;
    if (
      new_password !== confirm_password &&
      !Validate("password", new_password)
    ) {
      this.setState({
        confirmPasswordError: t("error_password_not_same"),
      });
    } else {
      this.setState({
        confirmPasswordError: "",
      });
    }
    return new_password === confirm_password;
  };

  _validateForm = () => {
    let valid = true;
    const { email, new_password, confirm_password, password, validConsent } = this.state;

    valid =
      valid &&
      new_password === confirm_password &&
      !Validate("password", new_password);

    if (password === "") {
      valid = false;
    }

    if (!email || email === "") {
      valid = false;
    }

    valid = valid && validConsent;

    return valid;
  };

  _change = () => {
    const obj = {
      old_password: this.state.password,
      email: this.state.email,
      new_password: this.state.new_password,
      newsletter: this.state.newsletter
    };
    this.setState({ formError: null });
    changePassword(obj)
      .then(() => {
        axiosApi("account", {}, "get").then((dataUser) => {
          // stockage user dans redux
          this.props.setAccountDatas(dataUser);
          this.setState({ redirect: true });
        });
      })
      .catch((err) => {
        this.setState({ formError: err });
      });
    return;
  };

  continue = (e) => {
    e.preventDefault();
    let valid = true;

    valid = this.password !== "" && valid;
    valid = this._validatePasswordConfirm() && valid;
    valid = this.state.validConsent && valid;
    if (valid) {
      this._change();
    }
  };

  render() {
    const { t } = this.props;
    const { optins } = this.state;

    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    return (
      <div>
        <form className="default-container col-flex">
          <div className="mv20 width-30 text-center">
            <strong>
              <p>{t('welcome')} {this.props.account.firstname}</p>
              <p> {t('change_password_to_validate')} </p>
            </strong>
          </div>
          <InsInput
            onChange={this.handleChange("email")}
            type="email"
            name="login_password"
            placeholder={t("email_address")}
            error={this.state.emailError}
          />
          <InsInput
            onChange={this.handleChange("password")}
            type="password"
            name="login_password"
            placeholder={t("current_password")}
            error={this.state.passwordError}
          />
          <InsInput
            onChange={this.handleChange("new_password")}
            onBlur={() => {
              this._validatePasswordConfirm();
            }}
            type="password"
            name="login_password"
            placeholder={t("new_password")}
            error={this.state.newPasswordError}
          />
          <InsInput
            onChange={this.handleChange("confirm_password")}
            type="password"
            name="login_password"
            onBlur={() => {
              this._validatePasswordConfirm();
            }}
            placeholder={t("password_confirm")}
            error={this.state.confirmPasswordError}
          />
          <div className="step3-validate-password">
            <ValidatePassword value={this.state.new_password}>
              {t("help_password")}
            </ValidatePassword>
          </div>
          <div className="bottom-container">
            {this.state.formError && (
              <p className="width-30 error-msg">{this.state.formError}</p>
            )}

            <ConnectOptin
                optins={optins}
                updateOptins={(data) => this.setState({optins: data})}
                updateNewsletter={(bool) => this.setState({newsletter: bool})}
                updateValidConsent={(bool) => this.setState({validConsent: bool})}
                required={false}
            />

            <p className="width-30 small-text">
              {t("required_only")}
            </p>
            <InsButton
              text={t("validate")}
              onClick={this.continue}
              disabled={!this._validateForm()}
            />
          </div>
        </form>
        <div className="lang-switcher-wrapper">
          <FixedLangSwitcher />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  account: state.account,
  config: state.config,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setAccountDatas: (datas) => {
      dispatch(accountActions.setAccountDatas(datas));
    },
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
);
